import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useCallback, useMemo } from 'react';

import { CommonLink } from '../../../components/common/Forms/Button';
import { useAuth } from '../../../context/AuthContext';
import {
  loginToBookAtSiteUri,
  patientAddToHospitalUri,
} from '../../../routes/AppRoutes';
import {
  TrustMiniSite,
  TrustMiniSiteCategory,
} from '../../../types/trustMiniSites';
import {
  TrustMiniSiteListItem,
  TrustMiniSiteListItemName,
} from './TrustMiniSitePage.styled';

interface Props {
  trustMiniSite: TrustMiniSite;
  category: TrustMiniSiteCategory;
}

export const TrustMiniSiteCategorySitesList = ({
  trustMiniSite: { sites },
  category,
}: Props) => {
  const { t } = useCommonTranslation();
  const { sangixUser } = useAuth();
  sites = useMemo(
    () =>
      sites
        ?.filter((site) => site.categories?.includes(category.id))
        .sort((a, b) => a.name.localeCompare(b.name)) ?? [],
    [sites, category.id],
  );

  const generateBookUri = useCallback(
    (siteId: string) => {
      if (!sangixUser) {
        return loginToBookAtSiteUri(siteId);
      } else {
        return patientAddToHospitalUri(siteId);
      }
    },
    [sangixUser],
  );

  return (
    <>
      {sites.map((site) => (
        <TrustMiniSiteListItem key={site.id}>
          <TrustMiniSiteListItemName>{site.name}</TrustMiniSiteListItemName>
          <CommonLink variant="primary" to={generateBookUri(site.id)}>
            {t('book')}
          </CommonLink>
        </TrustMiniSiteListItem>
      ))}
    </>
  );
};
